module.exports = __webpack_public_path__ + "img/03_full.47dea908.jpg";